<template>
  <div class="content-wrapper">
    <div id="skeduler-container" class="skeduler-container">
      {{ timestamp }}
      <div class="skeduler-headers-scheduler-scheduler">
        <div
          :class="flexDay"
          v-for="(timing, index) in timingItems"
          :key="index"
        >
          <div class="media-sch">
            <div class="media-body">
              <h4 :class="timing.showTime ? ` text-primary` : `media-heading`">
                {{ timing.name }}
              </h4>
              <p :class="timing.showTime ? ` text-primary` : ``">
                {{ timing.date }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="skeduler-main">
        <div class="skeduler-main-timeline">
          <div></div>
          <div>01:00</div>
          <div></div>
          <div>02:00</div>
          <div></div>
          <div>03:00</div>
          <div></div>
          <div>04:00</div>
          <div></div>
          <div>05:00</div>
          <div></div>
          <div>06:00</div>
          <div></div>
          <div>07:00</div>
          <div></div>
          <div>08:00</div>
          <div></div>
          <div>09:00</div>
          <div></div>
          <div>10:00</div>
          <div></div>
          <div>11:00</div>
          <div></div>
          <div>12:00</div>
          <div></div>
          <div>13:00</div>
          <div></div>
          <div>14:00</div>
          <div></div>
          <div>15:00</div>
          <div></div>
          <div>16:00</div>
          <div></div>
          <div>17:00</div>
          <div></div>
          <div>18:00</div>
          <div></div>
          <div>19:00</div>
          <div></div>
          <div>20:00</div>
          <div></div>
          <div>21:00</div>
          <div></div>
          <div>22:00</div>
          <div></div>
          <div>23:00</div>
          <div></div>
          <div>24:00</div>
        </div>
        <div
          :class="`skeduler-main-body ` + ClassDay"
          v-for="(timing, timingIndex) in timingItems"
          :key="timingIndex.id"
        >
          <div :class="ClassDay">
            <div
              class="skeduler-task-placeholder"
              v-for="(event, eventIndex) in timing.event_person"
              :key="eventIndex"
            >
              <div
                class=""
                @click="editEvent(timing.id)"
                :style="styleEvent(timing) + topDrag"
                :title="
                  convertTimeTitle(timing.start_time) +
                  `-` +
                  convertTimeTitle(timing.end_time)
                "
                @dragstart="dragStart"
                @drag="dragging"
                draggable="true"
                :id="`dragtarget-` + timingIndex"
              >
                <div>
                  <div>از {{ event.start }} تا {{ event.end }}</div>
                  <div>
                    {{ event.date }}
                    <span v-if="event.location">({{ event.location }})</span>
                  </div>
                </div>
              </div>
              <span
                v-if="timing.showTime"
                class="showTime"
                :style="`${timeNow(timing.timeNow, 'line')}`"
              ></span>
              <span
                v-if="timing.showTime"
                class="circleShowTime"
                :style="`${timeNow(timing.timeNow, 'circle')}`"
              ></span>
            </div>

            <div
              :class="`skeduler-cell ` + ClassDay"
              v-for="(item, cell) in cells"
              :key="item"
              @click="createEvent(cell, timing.date)"
              @drop="drop"
              @dragover="allowDrop"
              @dragenter="dragEnter"
              @dragleave="dragLeave"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_edit_scheduler"
      size="lg"
      ok-only
      hide-footer
    >
      <b-form @submit.prevent="addEvent">
        <b-row>
          <b-col xs="12" md="12">
            <b-form-group
              :label="$lang.event_caption"
              label-for="event_caption"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.event_caption"
                :rules="$v.event_caption.$params"
              />
              <b-form-input
                id="event_caption"
                type="text"
                :autocomplete="$lang.event_caption"
                :state="
                  $v.event_caption.$dirty ? !$v.event_caption.$error : null
                "
                v-model="$v.event_caption.$model"
              >
              </b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.event_caption.required"
                id="event_caption-feedback"
              >
                {{ $lang.error_required | replace($lang.event_caption) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col xs="12" md="12">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="$lang.selectedMood"
                :rules="$v.selectedMood.$params"
              />
              <b-form-radio-group
                id="btn-radios-1"
                v-model="selectedMood"
                buttons
                button-variant="outline-primary"
                :options="optionsMood"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col xs="12" md="12">
            <b-form-group
              :label="$lang.datetime"
              label-for="datetime"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.datetime"
                :rules="$v.datetime.$params"
              />
              <date-picker
                v-model="$v.datetime.$model"
                :state="$v.datetime.$dirty ? !$v.datetime.$error : null"
                format="YYYY/MM/DD"
                display-format="dddd jDD jMMMM jYYYY"
                min="1950/01/02"
                max="1999/12/31"
                inputReq="true"
                type="date"
                :class="
                  $v.datetime.$dirty
                    ? $v.datetime.$error
                      ? 'invalid-date'
                      : 'valid-date'
                    : null
                "
              >
              </date-picker>
              <b-form-invalid-feedback
                :style="{ display: $v.datetime.$error ? 'block' : 'none' }"
                id="datetime-feedback"
              >
                {{ $lang.error_required | replace($lang.datetime) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col xs="12" md="6">
            <b-form-group
              :label="$lang.timeStart"
              label-for="timeStart"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.timeStart"
                :rules="$v.timeStart.$params"
              />
              <date-picker
                v-model="$v.timeStart.$model"
                :state="$v.timeStart.$dirty ? !$v.timeStart.$error : null"
                inputReq="true"
                type="time"
                :class="
                  $v.timeStart.$dirty
                    ? $v.timeStart.$error
                      ? 'invalid-date'
                      : 'valid-date'
                    : null
                "
              >
              </date-picker>
              <b-form-invalid-feedback
                :style="{ display: $v.timeStart.$error ? 'block' : 'none' }"
                id="timeStart-feedback"
              >
                {{ $lang.error_required | replace($lang.timeStart) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col xs="12" md="6">
            <b-form-group
              :label="$lang.timeEnd"
              label-for="timeEnd"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.timeEnd"
                :rules="$v.timeEnd.$params"
              />
              <date-picker
                v-model="$v.timeEnd.$model"
                :state="$v.timeEnd.$dirty ? !$v.timeEnd.$error : null"
                inputReq="true"
                type="time"
                :class="
                  $v.timeEnd.$dirty
                    ? $v.timeEnd.$error
                      ? 'invalid-date'
                      : 'valid-date'
                    : null
                "
              >
              </date-picker>
              <b-form-invalid-feedback
                :style="{ display: $v.timeEnd.$error ? 'block' : 'none' }"
                id="timeEnd-feedback"
              >
                {{ $lang.error_required | replace($lang.timeEnd) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col xs="12" md="12">
            <b-form-group
              :label="$lang.location"
              label-for="location"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.location"
                :rules="$v.location.$params"
              />
              <b-form-input
                id="location"
                type="text"
                :autocomplete="$lang.location"
                :state="$v.location.$dirty ? !$v.location.$error : null"
                v-model="$v.location.$model"
              >
              </b-form-input>
              <b-form-invalid-feedback
                :style="{ display: $v.location.$error ? 'block' : 'none' }"
                id="location-feedback"
              >
                {{ $lang.error_required | replace($lang.location) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col xs="12" md="12">
            <b-form-group
              label-for="location"
              :label-cols="this.$config.form.labelCol"
            >
              <template class="d-flex" slot="label">
                <div>
                  {{ $lang.alarm }}
                  <i
                    @click="addNotification"
                    class="fa fa-plus cursor-pointer text-info"
                    aria-hidden="true"
                  ></i>
                </div>
              </template>
              <div
                class="d-flex mt-1"
                ref="addNotif"
                v-for="(itemNotif, itemNotifIndex) in NumberNotif"
                :key="itemNotifIndex"
              >
                <b-form-select
                  class="col-2"
                  v-model="itemNotif.selectedMoodSend"
                  :options="MoodSendoptions"
                >
                </b-form-select>
                <b-form-input
                  class="col-2"
                  id="TimeNotif"
                  type="number"
                  v-model="itemNotif.TimeNotif"
                  :autocomplete="$lang.TimeNotif"
                >
                </b-form-input>
                <b-form-select
                  class="col-2"
                  v-model="itemNotif.selectedMoodTime"
                  :options="MoodTimeoptions"
                >
                </b-form-select>

                <span class="pt-2 pl-2"
                  ><i
                    class="fa fa-trash text-danger"
                    @click="removeNotification(itemNotifIndex)"
                    aria-hidden="true"
                  ></i
                ></span>
              </div>
            </b-form-group>
          </b-col>
          <b-col xs="12" md="12">
            <requiredComponent
              slot="label"
              :label="$lang.description"
              :rules="$v.description.$params"
            />
          </b-col>
          <b-col xs="12" md="12">
            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="view_edit_scheduler = false"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { required } from "vuelidate/lib/validators";

export default {
  name: "scheduler",
  validations: {
    event_caption: {
      required,
    },
    datetime: {
      required,
    },
    location: {},
    selectedMood: {},
    description: {},
    timeEnd: {},
    timeStart: {},
  },
  props: {
    kindscheduler: {
      type: String,
      default: "",
    },
    timeGrid: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      cells: [...Array(48)],
      name: null,
      timingItems: [],
      transform: "",
      timestamp: "",
      topDrag: "",
      view_edit_scheduler: false,
      location: null,
      datetime: null,
      description: null,
      selectedMood: "blue",
      optionsMood: [
        {
          text: this.$lang.event,
          value: "0",
        },
        {
          text: this.$lang.reminder,
          value: "1",
        },
      ],
      MoodSendoptions: [
        {
          text: this.$lang.Notification,
          value: 0,
        },
        {
          text: this.$lang.email,
          value: 1,
        },
        {
          text: this.$lang.sms,
          value: 2,
        },
      ],

      MoodTimeoptions: [
        {
          text: this.$lang.minute,
          value: 0,
        },
        {
          text: this.$lang.day,
          value: 1,
        },
        {
          text: this.$lang.hour,
          value: 2,
        },
      ],
      NumberNotif: [
        {
          selectedMoodTime: 0,
          selectedMoodSend: 0,
          TimeNotif: 20,
        },
      ],
      itemNotif: {
        selectedMoodTime: 0,
        selectedMoodSend: 0,
        TimeNotif: 20,
      },
    };
  },
  methods: {
    removeNotification(index) {
      this.NumberNotif.splice(index, 1);
    },
    addNotification() {
      this.NumberNotif.push({
        selectedMoodTime: 0,
        selectedMoodSend: 0,
        TimeNotif: 20,
      });
    },
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      } // add zero in front of numbers < 10
      return i;
    },
    timeNow(time, type) {
      if (typeof time != "undefined" && time != null) {
        const res = time.split(":");
        const top = res[0] + "." + Math.round(res[1]);
        if (type == "line") return `top:${top * 54}px`;
        if (type == "circle") return `top:${top * 53.8}px`;
      }
    },
    convertTime(time) {
      if (typeof time != "undefined" && time != null) {
        var res = time.split(":");
        return res[0] + "." + Math.round(res[1]);
      }
    },
    convertTimeTitle(time) {
      if (typeof time != "undefined" && time != null) {
        var res = time.split(":");
        return res[0] + ":" + res[1];
      }
    },
    editEvent(itemId) {
      this.view_edit_scheduler = true;
      const data = this.timingItems.find((x) => x.id == itemId);
      this.name = data.name;
    },
    createEvent(index, date) {
      this.view_edit_scheduler = true;
      const time = Math.round(index / 2);
      this.timeStart = time;
      this.timeEnd = time + 1;
      this.datetime = date;
    },
    styleEvent(timing) {
      const top = this.convertTime(timing.start_time) * 54.4;
      const height =
        (this.convertTime(timing.end_time) -
          this.convertTime(timing.start_time)) *
        54;
      if (this.kindscheduler == "day")
        return `top: ${top}px; height: ${height}px; width: 100%;background-color:#039be5`;
      if (this.kindscheduler == "weak")
        return `top: ${top}px; height: ${height}px; width: 186px; right: 0px;background-color:#039be5`;
    },
    dragStart(event) {
      var format = "Text";
      const data = event.dataTransfer.setData("id", event.target.id);
      event.target.style.border = "3px dotted #039be5";
    },
    dragging(event) {
      event.target.style.border = "3px dotted #039be5";
    },
    dragEnter(event) {
      event.target.style.outline = "3px dotted #039be5";
    },
    dragLeave(event) {
      event.target.style.outline = "";
    },
    allowDrop(event) {
      event.preventDefault();
      if (event.target.getAttribute("draggable") == "true")
        event.dataTransfer.dropEffect = "none";
      // dropping is not allowed
      else event.dataTransfer.dropEffect = "all"; // drop it like it's hot
    },
    drop(event) {
      event.preventDefault();
      event.target.style.outline = "";
      var data = event.dataTransfer.getData("id");
      var dragged = document.getElementById(data);
      event.target.appendChild(dragged);
      dragged.className += " dropped";
    },

    genetrateScheduler() {
      if (this.kindscheduler == "day") {
        this.ClassDay = "w-100";
        this.flexDay = "flex-100";
        this.timingItems = [
          {
            id: 0,
            name: "شنبه",
            date: "1397/03/08",
            start_time: "01:00:00",
            end_time: "02:00:00",
            timeNow: "14:30:00",
            showTime: true,
            event_person: [
              {
                start: "20:30:00",
                end: "21:30:00",
                location: "مشهد",
                note: "",
                date: "1397/03/08 دو شنبه ",
              },
            ],
          },
        ];
      }
      if (this.kindscheduler == "weak") {
        this.ClassDay = "";
        this.flexDay = "";
        this.timingItems = [
          {
            id: 0,
            name: "شنبه",
            date: "1397/03/08",
            start_time: "02:30:00",
            end_time: "03:30:00",
            event_person: [
              {
                start: "20:30:00",
                end: "21:30:00",
                note: "",
                date: "1397/03/08 شنبه",
              },
            ],
          },
          {
            id: 1,
            name: "یک شنبه",
            date: "1397/03/08",
            start_time: "00:00:00",
            end_time: "24:00:00",
            timeNow: "13:00:00",
            showTime: true,
            event_person: [
              {
                start: "13:00:00",
                end: "24:00:00",
                note: "بدردود",
                date: "1397/03/08 یک شنبه",
              },
            ],
          },
          {
            id: 2,
            name: "دو شنبه",
            date: "1397/03/08",
            start_time: "17:30:00",
            end_time: "21:30:00",
            event_person: [
              {
                start: "20:30:00",
                end: "21:30:00",
                location: "مشهد",
                note: "",
                date: "1397/03/08 دو شنبه ",
              },
            ],
          },
          {
            id: 3,
            name: "سه شنبه",
            date: "1397/03/08",
            start_time: "18:30:00",
            end_time: "21:00:00",
            event_person: [
              {
                start: "20:30:00",
                end: "21:30:00",
                note: "",
                location: "تهران",
                date: "1397/03/08 دو شنبه ",
              },
            ],
          },
          {
            id: 4,
            name: "دو شنبه",
            date: "1397/03/08",
            start_time: "20:30:00",
            end_time: "21:30:00",
            event_person: [
              {
                start: "15:30:00",
                end: "16:30:00",
                note: "",
                location: "ابادان",
                date: "1397/03/08 دو شنبه ",
              },
            ],
          },
          {
            id: 5,
            name: "سه شنبه",
            date: "1397/03/08",
            start_time: "20:30:00",
            end_time: "21:30:00",
            event_person: [
              {
                start: "20:30:00",
                end: "21:30:00",
                note: "",
                date: "1397/03/08 دو شنبه ",
              },
            ],
          },
          {
            id: 6,
            name: "چهار شنبه",
            date: "1397/03/08",
            start_time: "14:00:00",
            end_time: "15:00:00",
            event_person: [
              {
                start: "22:30:00",
                end: "23:30:00",
                note: "",
                date: "1397/03/08 دو شنبه ",
              },
            ],
          },
          {
            id: 7,
            name: "پنج شنبه",
            date: "1397/03/08",
            start_time: "14:30:00",
            end_time: "16:30:00",
            event_person: [
              {
                start: "23:00:00",
                end: "24:00:00",
                note: "",
                date: "1397/03/08 دو شنبه ",
              },
            ],
          },
          {
            id: 8,
            name: "جمعه",
            date: "1397/03/08",
            start_time: "20:30:00",
            end_time: "21:30:00",
            event_person: [
              {
                start: "14:30:00",
                end: "21:30:00",
                note: "",
                date: "1397/03/08 دو شنبه ",
              },
            ],
          },
        ];
      }
    },
    addEvent() {
      this.view_edit_scheduler = false;
      this.timeStart = "";
      this.timeEnd = "";
    },
  },
  watch: {
    kindscheduler() {
      this.genetrateScheduler();
    },
    topDrag() {},
  },
  created() {
    this.genetrateScheduler();
  },
};
</script>
<style>
.inline-block {
  width: 200px;
  display: inline-block;
}

.text-link {
  color: white !important;
}

.skeduler-container {
  overflow-x: scroll;
}

.skeduler-container * {
  /* box-sizing: content-box; */
  background-color: transparent;
}

.skeduler-headers-scheduler {
  /* border-left: 1px solid #b0cee9; */
  display: flex;
  padding-right: 50.9px;
  position: relative;
}

.skeduler-headers-scheduler:before {
  /* border-top: 1px solid #b0cee9; */
  content: "";
  width: 60px;
  position: absolute;
  left: 0;
}

.skeduler-headers-scheduler > div {
  flex: 0 0 200px;
  height: 70px;
  padding-top: 10px;
  /* background-color: #fce4ec;
    border-left: 1px solid #f8bbd0; */
  border-bottom: 1px solid #0000004a;
  /* border-top: 1px solid #f8bbd0; */
  text-align: center;
}

.skeduler-headers-scheduler > div:last-child,
.skeduler-main-body > div > div.skeduler-cell {
  /* border-right: 1px solid #0000004a; */
}

.skeduler-headers-scheduler > div:last-child,
.skeduler-main-body > div > div.skeduler-cell:nth-child(odd) {
  border-bottom: 1px solid #0000004a;
}

.skeduler-main {
  display: flex;
}

.skeduler-main-timeline {
  margin-top: 0;
  border-left: 1px solid #0000004a;
}

.skeduler-main-timeline div {
  position: relative;
  width: 50px;
  height: 27px;
  text-align: left;
  padding-left: 10px;
  padding-top: 16px;
  color: #333333;
  /* border-right: 1px solid #ffc1e3;
    border-left: 1px solid #ffc1e3; */
}

.skeduler-main-timeline div:nth-child(even)::after {
  position: absolute;
  content: "";
  width: 1px;
  height: 7px;
  background: #aaacae;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  bottom: -3px;
  left: 2px;
  /* border-right: 1px solid #ffc1e3;
    border-left: 1px solid #ffc1e3; */
}

.skeduler-main-timeline div:first-child {
  /* border-top: 1px solid #ffc1e3; */
}

.skeduler-main-body {
  display: flex;
}

.skeduler-main-timeline div,
.skeduler-main-body > div > div.skeduler-cell {
  background-color: transparent;
}

.skeduler-main-timeline div:nth-child(even),
.skeduler-main-body > div > div.skeduler-cell:nth-child(odd) {
  /* border-top: 1px dotted #b0cee9; */
  /* border-bottom: 1px solid #0000004a; */
}

.skeduler-main-body > div > div.skeduler-cell {
  width: 200px;
  height: 27px;
  border-left: 1px solid #aaacae;
}

.skeduler-main-body > div > .skeduler-task-placeholder {
  height: 0;
  position: relative;
}

.skeduler-main-body > div > .skeduler-task-placeholder > div {
  position: absolute;
  overflow: hidden;
  /*background-color: #576D7C;*/
  /*background-color: rgba(22,22,130,.6);*/
  /* background-color: rgba(236, 64, 122, 0.7); */
  border-right: 3px solid #039be5;
  padding: 10px;
  box-sizing: border-box;
  /* box-shadow: -5px -5px 8px rgba(0, 0, 0, 0.35); */
  margin-top: 2px;
  cursor: pointer;
  color: #ffffff;
  /* word-wrap: break-word; */
  min-width: 0;
  min-height: 30px;
  transition: all 0.4s;
  border-radius: 4px;
}

.flex-100 {
  flex: 0 0 100% !important;
}

.showTime {
  width: 100%;
  height: 4px;
  top: 300px;
  background: red;
  position: absolute;
  left: 0;
  cursor: pointer;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}

.circleShowTime {
  width: 10px;
  height: 10px;
  top: 297px;
  background: red;
  border-radius: 50%;
  background: red;
  position: absolute;
  right: 0;
}

.cursor-pointer {
  cursor: pointer;
}

.dropped {
  cursor: pointer;
  color: #ffffff;
}

/*
.skeduler-main-body > div > .skeduler-task-placeholder > div:hover {
  box-shadow: 0 .25em .5em rgba(0,0,0,.5);
  background-color: #3A9852;
  min-width: 200px;


} */
</style>
